// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__17ZTm","content":"ManualTimeModal_content__2hHXd"};